import React, { useEffect, useState } from "react";
import {
    Box,
    Typography,
    Grid,
    Card,
    CardMedia,
    CardContent,
    CircularProgress,
    Container,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import Header from "../../../../common/Header";
import Footer from "../../../../common/Footer";
import { config } from "../../../../config/config";
import { apiList, invokeApi } from "../../../../services/apiServices";
import { useCookies } from "react-cookie";

const FeaturesPage = () => {
    const navigate = useNavigate();
    const [featureData, setFeatureData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [cookies] = useCookies();

    const handleGetFeatures = async () => {
        try {
            setLoading(true);
            const response = await invokeApi(
                config.getMyCollege + apiList.getFeatures,
                {},
                cookies
            );

            if (response?.status === 200) {
                setFeatureData(response.data.features || []);
            } else {
                console.error("Failed to fetch features:", response);
                setError("Failed to load features.");
            }
        } catch (error) {
            console.error("Error fetching features:", error);
            setError("An error occurred while fetching features.");
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        handleGetFeatures();
        window.scrollTo(0, 0);
    }, []);

    return (
        <>
            <Header />
            <Box sx={{ bgcolor: "#fff", py: 8, minHeight: "80vh" }}>
                <Container maxWidth="xl">
                    <Typography
                        variant="h3"
                        align="center"
                        gutterBottom
                        sx={{
                            fontFamily: "Montserrat, sans-serif",
                            fontWeight: "bold",
                            mb: 6,
                            color: "#1A1A1A",
                        }}
                    >
                        OUR FEATURES
                    </Typography>

                    {loading ? (
                        <Box sx={{ display: "flex", justifyContent: "center", py: 10 }}>
                            <CircularProgress color="primary" />
                        </Box>
                    ) : error ? (
                        <Box sx={{ textAlign: "center", py: 10 }}>
                            <Typography color="error" variant="h6">
                                {error}
                            </Typography>
                        </Box>
                    ) : (
                        <Grid container spacing={4}>
                            {featureData.map((item, index) => (
                                <Grid item key={index} xs={12} sm={6} md={4}>
                                    <Card
                                        sx={{
                                            height: "100%",
                                            display: "flex",
                                            flexDirection: "column",
                                            boxShadow: "0 4px 20px rgba(0,0,0,0.08)",
                                            transition: "transform 0.3s ease, box-shadow 0.3s ease",
                                            "&:hover": {
                                                transform: "translateY(-8px)",
                                                boxShadow: "0 12px 30px rgba(0,0,0,0.12)",
                                            },
                                            cursor: "pointer",
                                            borderRadius: "12px",
                                            overflow: "hidden",
                                        }}
                                        onClick={() => navigate(`/feature/${item.ogUrl}`)}
                                    >
                                        <CardMedia
                                            component="img"
                                            image={item.featuredUrl}
                                            alt={item.featureTitle}
                                            sx={{
                                                height: 240,
                                                objectFit: "cover",
                                            }}
                                        />
                                        <CardContent sx={{ flexGrow: 1, p: 3 }}>
                                            <Typography
                                                variant="h6"
                                                fontWeight="bold"
                                                color="#1A1A1A"
                                                gutterBottom
                                                sx={{ fontFamily: "Montserrat, sans-serif" }}
                                            >
                                                {item.featureTitle}
                                            </Typography>
                                            <Typography
                                                variant="body2"
                                                color="text.secondary"
                                                sx={{
                                                    fontFamily: "Montserrat, sans-serif",
                                                    display: "-webkit-box",
                                                    WebkitLineClamp: 3,
                                                    WebkitBoxOrient: "vertical",
                                                    overflow: "hidden",
                                                }}
                                                dangerouslySetInnerHTML={{
                                                    __html: item.featureContent,
                                                }}
                                            />
                                            <Typography
                                                variant="body2"
                                                color="primary"
                                                mt={2}
                                                sx={{
                                                    textDecoration: "underline",
                                                    fontWeight: 600,
                                                    fontFamily: "Montserrat, sans-serif",
                                                }}
                                            >
                                                Read More
                                            </Typography>
                                        </CardContent>
                                    </Card>
                                </Grid>
                            ))}
                        </Grid>
                    )}
                </Container>
            </Box>
            <Footer variant="light" />
        </>
    );
};

export default FeaturesPage;
